<template>
  <CreateSurveyModal v-if="showCreateSurveyModal" @closeModal="closeModal" />
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Pesquisas</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Cadastre os templates de pesquisa
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Cadastrar Pesquisa"
          @click="showCreateSurveyModal = true"
        >
          Cadastrar Pesquisa
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListSurveys v-else :surveys="surveys" />
  </div>
</template>

<script>
import CreateSurveyModal from '@/components/params/surveys/CreateSurveyModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListSurveys from '@/components/params/surveys/ListSurveys.vue'

export default {
  name: 'Surveys',

  components: {
    CreateSurveyModal,
    LoadingData,
    ListSurveys,
  },

  data() {
    return {
      isLoadingData: true,
      showCreateSurveyModal: false,
      surveys: [],
    }
  },

  methods: {
    async getSurveys() {
      try {
        this.surveys = await this.$store.dispatch('getSurveys')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeModal(needReload) {
      if (needReload) {
        this.getSurveys()
      }
      this.showCreateSurveyModal = false
    },
  },

  mounted() {
    this.getSurveys()
  },
}
</script>
